import { useTranslation } from 'react-i18next'

import { EntityProfileHeaderEditTitleModal } from '../../../../Entity'
import { useNewsboardPostProfileContext } from '../../../Newsboard.hooks'
import {
  getNewsboardPostProfileEditPostAgeInitialValues,
  getNewsboardPostProfileEditPostAgePayload,
  getNewsboardPostProfileEditPostAgeValidationSchema,
  NewsboardPostProfileHeaderEditPostAgeField,
} from '../../../NewsboardPostProfileHeaderEditPostAgeField'

export function useNewsboardPostProfileEditPostAge() {
  const { handleCloseModal, handleUpdateEntity, postData, setModal } =
    useNewsboardPostProfileContext()

  const { t } = useTranslation()

  async function handleSubmit({ value }) {
    await handleUpdateEntity(value)
    handleCloseModal()
  }

  function handleOpenModal() {
    setModal(
      <EntityProfileHeaderEditTitleModal
        Fields={NewsboardPostProfileHeaderEditPostAgeField}
        formTitle='NewsboardPostProfile.EditPostAgeModalTitleKey'
        getPayload={getNewsboardPostProfileEditPostAgePayload}
        initialValues={getNewsboardPostProfileEditPostAgeInitialValues(
          postData?.post_age_to_add_new_user
        )}
        validationSchema={getNewsboardPostProfileEditPostAgeValidationSchema(t)}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />
    )
  }

  return { handleOpenModal }
}
